import { Box, CircularProgress, Stack } from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { chapterSummeryService } from 'src/Services/ApiHandlers/chapterSummeryService';
import DeleteModal from 'src/sections/PopUp/DeleteModal';
import ChapterSummerizeItem from './ChapterSummerizeItem';

const ChapterSummerizeList = ({ book_id, slug, is_header, is_clone, is_header_two }) => {
  const [summeries, setSummeries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const deleteRefId = useRef(undefined);

  const getSummeries = useCallback(async () => {
    setLoading(true);
    const response = await chapterSummeryService.get({ book_id, slug, is_header, is_clone, is_header_two });
    if (response.code === 200) {
      setSummeries(response.data);
    }
    setLoading(false);
  }, [book_id, slug, is_header, is_clone, is_header_two]);

  useEffect(() => {
    getSummeries();
  }, [getSummeries]);

  const deleteModal = (id) => {
    deleteRefId.current = id;
    setModalOpen(true);
  };

  const deleteHandler = async () => {
    setModalOpen(false);
    const response = await chapterSummeryService.delete(deleteRefId.current);
    try {
      if (response.code === 200) {
        deleteRefId.current = undefined;
        getSummeries();
      } else {
        toast.error('Failed to delete');
      }
    } catch (error) {
      toast.error('Failed to delete');
    }
  };

  if (loading)
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          width: '100%',
        }}
      >
        <CircularProgress />
      </Box>
    );

  return (
    <Stack
      spacing={2}
      sx={{
        fontSize: '18px',
        fontFamily: '-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Ubuntu,sans-serif',
        p: '1rem',
      }}
    >
      {summeries.map((summary) => (
        <ChapterSummerizeItem key={summary._id} {...summary} onDelete={deleteModal} />
      ))}
      <DeleteModal setOpen={setModalOpen} open={modalOpen} deleteHandler={deleteHandler} />
    </Stack>
  );
};

export default ChapterSummerizeList;
